import { render, staticRenderFns } from "./ConflictPrompt.html?vue&type=template&id=c41490a4&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./ConflictPrompt.scss?vue&type=style&index=0&id=c41490a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41490a4",
  null
  
)

export default component.exports